module.exports = __webpack_public_path__ + "img/1f605.3bc4f2d.svg";